import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Application } from '../../../../enums/application.enums';
import { DOCUMENT } from '@angular/common';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html'
})
export class LoginDialogComponent {
  constructor(
    private readonly modalService: BsModalService,
    private readonly modalRef: BsModalRef,
    private readonly cs: CommonService,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    if (cs.isBrowser) {
      const element = this.document.getElementsByTagName('html');
      element.item(Application.ZERO).classList.add('modal-open');
      this.modalRef.onHidden.subscribe(() => {
        element.item(Application.ZERO).classList.remove('modal-open');
      });
    }
  }

  redirectTo(isLogin) {
    this.cs.closeMusicPlayerModal.next(true);
    if (isLogin) {
      this.router.navigate(['/auth/login']);
    } else {
      this.router.navigate(['/auth/signup']);
    }
    if (this.modalService?.config?.initialState) {
      if (Object.keys(this.modalService?.config?.initialState).length) {
        this.cs.status = this.modalService?.config?.initialState.status;
      }
    }
    this.modalService.hide();
  }

  onCloseClick() {
    this.modalService.setDismissReason(
      this.modalService?.config?.initialState?.status ? 'open-subscription' : ''
    );
    this.cs.status = '';
    this.modalService.hide();
  }
}
